"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCategoriesWithRestrictionsToJSON = exports.AdCategoriesWithRestrictionsFromJSONTyped = exports.AdCategoriesWithRestrictionsFromJSON = exports.instanceOfAdCategoriesWithRestrictions = exports.AdCategoriesWithRestrictionsRestrictionEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.AdCategoriesWithRestrictionsRestrictionEnum = {
    AudioCreationRestrictionAllProhibited: 'AUDIO_CREATION_RESTRICTION_ALL_PROHIBITED',
    AudioCreationRestrictionAllAllowed: 'AUDIO_CREATION_RESTRICTION_ALL_ALLOWED',
    AudioCreationRestrictionVoiceoverAllowed: 'AUDIO_CREATION_RESTRICTION_VOICEOVER_ALLOWED',
    AudioCreationRestrictionUploadAllowed: 'AUDIO_CREATION_RESTRICTION_UPLOAD_ALLOWED',
    AudioCreationRestrictionUnknown: 'AUDIO_CREATION_RESTRICTION_UNKNOWN',
    Unrecognized: 'UNRECOGNIZED'
};
/**
 * Check if a given object implements the AdCategoriesWithRestrictions interface.
 */
function instanceOfAdCategoriesWithRestrictions(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdCategoriesWithRestrictions = instanceOfAdCategoriesWithRestrictions;
function AdCategoriesWithRestrictionsFromJSON(json) {
    return AdCategoriesWithRestrictionsFromJSONTyped(json, false);
}
exports.AdCategoriesWithRestrictionsFromJSON = AdCategoriesWithRestrictionsFromJSON;
function AdCategoriesWithRestrictionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'parentId': !(0, runtime_1.exists)(json, 'parent_id') ? undefined : json['parent_id'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'restriction': !(0, runtime_1.exists)(json, 'restriction') ? undefined : json['restriction'],
        'audienceRestriction': !(0, runtime_1.exists)(json, 'audience_restriction') ? undefined : json['audience_restriction'],
    };
}
exports.AdCategoriesWithRestrictionsFromJSONTyped = AdCategoriesWithRestrictionsFromJSONTyped;
function AdCategoriesWithRestrictionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'parent_id': value.parentId,
        'id': value.id,
        'name': value.name,
        'restriction': value.restriction,
        'audience_restriction': value.audienceRestriction,
    };
}
exports.AdCategoriesWithRestrictionsToJSON = AdCategoriesWithRestrictionsToJSON;
